import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=9328cdc6&scoped=true"
import script from "./TextComponent.vue?vue&type=script&lang=js"
export * from "./TextComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9328cdc6",
  null
  
)

export default component.exports